module.exports = __webpack_public_path__ + "img/player.a706c411.png";